<template>
    <div class="page">
        <div class="header-container">
            <h1>Hinnasto</h1>
        </div>
        <div class="pricing-container">
            <div class="pricing-column left">
                <h2>Akupunktio</h2>
                <p>
                    <ul class="inline-list">
                        <li class="price-item">
                            Ensikäynti 90min &nbsp;<span class="dots"></span><span class="price">&nbsp; 80€</span>
                        </li>
                        <li class="price-item">
                            Jatkokäynti 60min &nbsp;<span class="dots"></span><span class="price">&nbsp; 50€</span>
                        </li>
                        <li class="additional-pricing">
                            Sarjakortti x3 &nbsp;<span class="dots"></span><span class="price">&nbsp; 140€</span>
                        </li>
                        <li class="additional-pricing">
                            Sarjakortti x5 &nbsp;<span class="dots"></span><span class="price">&nbsp; 225€</span>
                        </li>
                        <li class="price-item">
                            Arpihoito 30min &nbsp;<span class="dots"></span><span class="price">&nbsp; 45€</span>
                        </li>
                        <li class="additional-pricing">
                            Sarjakortti x3 &nbsp;<span class="dots"></span><span class="price">&nbsp; 110€</span>
                        </li>
                        <li class="additional-pricing">
                            Sarjakortti x5 &nbsp;<span class="dots"></span><span class="price">&nbsp; 180€</span>
                        </li>
                        <li>
                            <small class="disclaimer">
                                Arpihoidon suosittelen tehtäväksi tulineulalla, mutta voidaan tehdä myös tavallisilla neuloilla.
                            </small>
                        </li>
                        <li class="price-item">
                            Motorinen/sähköakupunktio 90min &nbsp;<span class="dots"></span><span class="price">&nbsp; 60€</span>
                        </li>
                        <li class="additional-pricing">
                            Sarjakortti x3 &nbsp;<span class="dots"></span><span class="price">&nbsp; 150€</span>
                        </li>
                        <li class="additional-pricing">
                            Sarjakortti x5 &nbsp;<span class="dots"></span><span class="price">&nbsp; 240€</span>
                        </li>
                        <li class="price-item">
                            Korva-akupunktio 40min &nbsp;<span class="dots"></span><span class="price">&nbsp; 35€</span>
                        </li>
                        <li class="additional-pricing">
                            Sarjakortti x3 &nbsp;<span class="dots"></span><span class="price">&nbsp; 90€</span>
                        </li>
                        <li class="additional-pricing">
                            Sarjakortti x5 &nbsp;<span class="dots"></span><span class="price">&nbsp; 140€</span>
                        </li>
                        <br />
                        <li class="price-item">
                            Akupunktio ja kuppaus yhdistelmähoito 90min &nbsp;<span class="dots"></span><span class="price">&nbsp; 90€</span>
                        </li>
                        <li class="additional-pricing">
                            Sarjakortti x3 &nbsp;<span class="dots"></span><span class="price">&nbsp; 250€</span>
                        </li>
                        <li class="additional-pricing">
                            Sarjakortti x5 &nbsp;<span class="dots"></span><span class="price">&nbsp; 400€</span>
                        </li>
                    </ul>
                </p>
            </div>
            <div class="pricing-column right">
                <h2>Kuivakuppaus</h2>
                <p>
                    <ul class="inline-list">
                        <li class="price-item">
                            30min &nbsp;<span class="dots"></span><span class="price">&nbsp; 50€</span>
                        </li>
                        <li class="additional-pricing">
                            Sarjakortti x3 &nbsp;<span class="dots"></span><span class="price">&nbsp; 140€</span>
                        </li>
                        <li>
                            <small class="disclaimer">Hoitoesimerkkejä: niska-hartiaseutu tai alaselkä</small>
                        </li>
                        <li class="price-item">
                            45min &nbsp;<span class="dots"></span><span class="price">&nbsp; 60€</span>
                        </li>
                        <li class="additional-pricing">
                            Sarjakortti x3 &nbsp;<span class="dots"></span><span class="price">&nbsp; 165€</span>
                        </li>
                        <li>
                            <small class="disclaimer">Hoitoesimerkkejä: niska-hartiaseutu ja selkä tai pakarat ja takareidet</small>
                        </li>
                        <li class="price-item">
                            60min &nbsp;<span class="dots"></span><span class="price">&nbsp; 70€</span>
                        </li>
                        <li class="additional-pricing">
                            Sarjakortti x3 &nbsp;<span class="dots"></span><span class="price">&nbsp; 190€</span>
                        </li>
                        <li>
                            <small class="disclaimer">Hoitoesimerkkejä: niska-hartiaseutu, selkä ja pakarat tai jalkapohjat ja pohkeet</small>
                        </li>
                        <li class="price-item">
                            90min &nbsp;<span class="dots"></span><span class="price">&nbsp; 100€</span>
                        </li>
                        <li class="additional-pricing">
                            Sarjakortti x3 &nbsp;<span class="dots"></span><span class="price">&nbsp; 280€</span>
                        </li>
                        <li>
                            <small class="disclaimer">Hoitoesimerkkejä: kokonaisvaltainen jalkojen hoito tai muu kokonaisvaltainen hoito</small>
                        </li>
                    </ul>
                </p>
            </div>
        </div>
        <p>
            Varaa ensikäynti, jos edellisestä hoitokerrasta luonani on kulunut aikaa yli vuosi.
            Ensikäynnillä tehdään kattava haastattelu, jossa käydään tarkasti vointiisi liittyvät asiat läpi.
            Jatkokäynnillä tehdään lyhyempi haastattelu. Motorista akupunktiota voidaan tehdä varatun ajan puitteissa myös jatkokäynnillä.
            Suosittelen kuitenkin varaamaan pidemmän ajan, jos tiedät haluavasi motorista akupunktiota.
            Tulineulaa voidaan hyödyntää normaalin akupunktion lisänä. Ajat ovat hoitokerralle varattuja enimmäisaikoja ja hoidosta riippuen aikaa saattaa kulua myös vähemmän.
        </p>
        <p>
            Teen myös koirille akupunktion harjoitushoitoja.
            Hoidon yhteydessä voidaan käyttää myös tarvittaessa laserterapiaa.
            Mikäli olet tulossa Espoon hoitohuoneelle voit varata ajan ajanvarauskalenterista normaalisti, mutta mainitse ajan olevan koiralle, hinta on -50% ihmisten hinnoista. Muissa tapauksissa olethan yhteydessä sähköpostitse tai puhelimitse.
        </p>
        <p>
            Teen myös koti-, vanhainkoti- ja yrityskäyntejä.
            Näihin lisätään +50% hoidon hinnasta ja mahdolliset kilometrikorvaukset, jos kohde on yli 10km päässä hoitohuoneelta katsottuna. Jos taloudessa on useampi hoidettava, vain yhdestä tarvitsee maksaa lisähinta. <strong>Mikäli haluat varata kotikäynnin, olethan yhteydessä sähköpostitse tai puhelimitse.</strong>
        </p>
        <p>
            Sarja- ja lahjakortit ovat voimassa 6 kuukautta ostopäivästä alkaen.
        </p>
        <p>
            <strong>Mikäli et pääse paikalle, peruthan aikasi viimeistään 24 tuntia ennen varauksen alkamisaikaa. Peruuttamattomista ajoista veloitetaan 50% hoidon hinnasta.</strong>
        </p>
    </div>
</template>

<script>
    export default {
        name: 'PricingPage'
    };
</script>

<style scoped>
    .header-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .pricing-container {
        display: flex;
        gap: 20px;
        margin: 0 auto;
        max-width: 1300px;
    }

    .pricing-column {
        flex: 1 1 50%;
        padding: 10px;
    }

    .treatment-link {
        color: #374a40;
        text-decoration: none;
        font-weight: bold;
        transition: color 0.3s;
        margin-bottom: 2rem;
    }

        .treatment-link:hover {
            text-decoration: underline;
        }

    .inline-list {
        padding: 1rem 0 1rem 0;
        width: 90%;
    }

        .inline-list li {
            align-items: center;
        }

    .price-item {
        margin-top: 0.75rem;
    }

    .additional-pricing {
        margin-left: 2rem;
    }

    .disclaimer {
        display: block;
        font-size: 1rem;
        color: #405c4c;
        margin-top: 2px;
        text-align: left;
    }

    .dots {
        border-bottom: 1px dashed #374a40;
        flex: 1;
    }

    .price {
        float: right;
    }

    @media (max-width: 768px) {
        .pricing-container {
            flex-direction: column;
        }

        .pricing-column {
            flex: 1 1 100%;
        }

        .inline-list {
            width: 100%;
        }
    }
</style>
